module.exports = __webpack_public_path__ + "static/sample-flyer-back-a823b05bcab37f6ecb568b28d30dd4c3.webp";